module.exports = __webpack_public_path__ + "img/hr.d5b15878.svg";